@if (!isOracle) {
	<h1>Not authorized to use this page.</h1>
}

@if (isOracle) {
	<div class="column spacing-24">
		<div class="row spacing-24">
			<app-cards class="column">
				<div style="padding: 1em 2em 2em 2em">
					<h1 i18n="@@@@deviceLookup-lookUpDeviceSerialNumber" class="title serial-number-title">
						Look up device by Serial Number
					</h1>
					<mat-form-field
						subscriptSizing="dynamic"
						appearance="outline"
						class="filter-row-child-half left max-width-510"
					>
						<mat-label i18n-label="deviceLookup-serialNumber">Serial Number</mat-label>
						<input matInput [(ngModel)]="serialNumber" data-automation-id="serial-number-input" />
					</mat-form-field>
					<button
						data-automation-id="lookup-device-button"
						mat-button
						(click)="lookupDevice()"
						style="margin-bottom: 25px; clear: both"
						class="primary-button filter-row-child-half left max-width-510"
						i18n="@@deviceLookup-lookupDevice"
					>
						Lookup Device
					</button>
				</div>
				@if (message) {
					<div style="padding-top: 1em; padding-left: 2em; clear: both">
						<h1 style="color: red" class="title">{{ message }}</h1>
					</div>
				}
			</app-cards>
		</div>
		@if (device) {
			<div class="row spacing-24">
				<app-cards class="column">
					<div class="padding-24">
						<h2 i18n="@@deviceLookup-deviceSummary">Device Summary</h2>
						<table>
							<tr>
								<th i18n="@@deviceLookup-deviceSummarySerialNumber">Device Serial Number:</th>
								<td>{{ device.serialNumber }}</td>
							</tr>
							<tr>
								<th i18n="@@deviceLookup-deviceSummaryStatus">Device Status:</th>
								<td>{{ device.status }}</td>
							</tr>
							<tr>
								<th i18n="@@deviceLookup-deviceSummaryOwnerCompany">Owner Company:</th>
								<td>{{ device.activeDeviceAssignment?.company?.name ?? 'none' }}</td>
							</tr>
							<tr>
								<th i18n="@@deviceLookup-deviceSummaryInstalledProperty">Installed Property:</th>
								<td>
									{{
										device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.name ?? 'none'
									}}
								</td>
							</tr>
							<tr>
								<th i18n="@@deviceLookup-deviceSummaryInstallationLocation">Installation Location:</th>
								<td>{{ device.activeDeviceAssignment?.activeInstallation?.installationLocation?.name ?? 'none' }}</td>
							</tr>
						</table>
					</div>
				</app-cards>
			</div>
			<div class="row spacing-24">
				<app-cards class="column">
					<div class="padding-24">
						<div class="section">
							<h2 i18n="@@deviceLookup-deviceInformation">Device Information</h2>
							<table>
								<tr>
									<th i18n="@@deviceLookup-deviceInformationId">id:</th>
									<td>{{ device.id }}</td>
								</tr>
								<tr>
									<th i18n="@@deviceLookup-deviceInformationSerialNumber">serialNumber:</th>
									<td>{{ device.serialNumber }}</td>
								</tr>
								<tr>
									<th i18n="@@deviceLookup-deviceInformationMountingBracketRequired">mountingBracketRequired:</th>
									<td>{{ device.mountingBracketRequired }}</td>
								</tr>
								<tr>
									<th i18n="@@deviceLookup-deviceInformationDecommissioned">decommissioned:</th>
									<td>{{ device.decommissioned }}</td>
								</tr>
								<tr>
									<th i18n="@@deviceLookup-deviceInformationCMC">cmc:</th>
									<td>{{ device.cmc }}</td>
								</tr>
								<tr>
									<th i18n="@@deviceLookup-deviceInformationStatus">status:</th>
									<td>{{ device.status }}</td>
								</tr>
							</table>
						</div>
						@if (device.activeDeviceAssignment) {
							<div class="section">
								<h2 i18n="@@deviceLookup-activeDeviceAssignment">Active Device Assignment</h2>
								<table>
									<tr>
										<th i18n="@@deviceLookup-activeDeviceAssignmentId">id:</th>
										<td>{{ device.activeDeviceAssignment.id }}</td>
									</tr>
									<tr>
										<th i18n="@@deviceLookup-activeDeviceAssignmentCompanyId">companyId:</th>
										<td>{{ device.activeDeviceAssignment.companyId }}</td>
									</tr>
									<tr>
										<th i18n="@@deviceLookup-activeDeviceAssignmentDeviceId">deviceId:</th>
										<td>{{ device.activeDeviceAssignment.deviceId }}</td>
									</tr>
									<tr>
										<th i18n="@@deviceLookup-activeDeviceAssignmentUtcStartDate">utcStartDate:</th>
										<td>{{ device.activeDeviceAssignment.utcStartDate }}</td>
									</tr>
									<tr>
										<th i18n="@@deviceLookup-activeDeviceAssignmentDeviceAdministrationGroupId">
											deviceAdministrationGroupId:
										</th>
										<td>{{ device.activeDeviceAssignment.deviceAdministrationGroupId }}</td>
									</tr>
									<tr>
										<th i18n="@@deviceLookup-activeDeviceAssignmentDeviceAdministraionGroupCmc">
											deviceAdministrationGroupCmc:
										</th>
										<td>{{ device.activeDeviceAssignment.deviceAdministrationGroupCmc }}</td>
									</tr>
								</table>
							</div>
						}
						@if (device.activeDeviceAssignment?.company) {
							<div class="section">
								<h2 i18n="@@deviceLookup-currentCompanyAssignment">Current Company Assignment</h2>
								<table>
									<tr>
										<th i18n="@@deviceLookup-currentCompanyAssignmentCompanyId">company.id:</th>
										<td>{{ device.activeDeviceAssignment?.company?.id }}</td>
									</tr>
									<tr>
										<th i18n="@@deviceLookup-currentCompanyAssignmentCompanyName">company.name:</th>
										<td>{{ device.activeDeviceAssignment?.company?.name }}</td>
									</tr>
									<tr>
										<th i18n="@@deviceLookup-currentCompanyAssignmentCompanySlugId">company.slugId:</th>
										<td>{{ device.activeDeviceAssignment?.company?.slugId }}</td>
									</tr>
									<tr>
										<th i18n="@@deviceLookup-currentCompanyAssignmentCompanyActive">company.active:</th>
										<td>{{ device.activeDeviceAssignment?.company?.active }}</td>
									</tr>
								</table>
							</div>
						}
						@if (device.activeDeviceAssignment?.activeInstallation) {
							<div class="section">
								<h2 i18n="@@deviceLookup-activeDeviceInstallation">Active Device Installation</h2>
								<table>
									<tr>
										<th i18n="@@deviceLookup-activeDeviceInstallationId">id:</th>
										<td>{{ device.activeDeviceAssignment?.activeInstallation?.id }}</td>
									</tr>
									<tr>
										<th i18n="@@deviceLookup-activeDeviceInstallationDeviceId">deviceId:</th>
										<td>{{ device.activeDeviceAssignment?.activeInstallation?.deviceId }}</td>
									</tr>
									<tr>
										<th i18n="@@deviceLookup-activeDeviceInstallationInstallationLocationId">
											installationLocationId:
										</th>
										<td>{{ device.activeDeviceAssignment?.activeInstallation?.installationLocationId }}</td>
									</tr>
									<tr>
										<th i18n="@@deviceLookup-activeDeviceInstallationUtcInstallDate">utcInstallDate:</th>
										<td>{{ device.activeDeviceAssignment?.activeInstallation?.utcInstallDate }}</td>
									</tr>
								</table>
							</div>
						}
						@if (device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location) {
							<div class="section">
								<h2 i18n="@@deviceLookup-installionProperty">Installation Property</h2>
								<table>
									<tr>
										<th i18n="@@deviceLookup-installionPropertyId">id:</th>
										<td>{{ device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.id }}</td>
									</tr>
									<tr>
										<th i18n="@@deviceLookup-installionPropertyName">name:</th>
										<td>
											{{ device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.name }}
										</td>
									</tr>
									<tr>
										<th i18n="@@deviceLookup-installionPropertyCompanyId">companyId:</th>
										<td>
											{{ device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.companyId }}
										</td>
									</tr>
									<tr>
										<th i18n="@@deviceLookup-installionPropertyAddressId">addressId:</th>
										<td>
											{{ device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.addressId }}
										</td>
									</tr>
									<tr>
										<th i18n="@@deviceLookup-installionPropertyActive">active:</th>
										<td>
											{{ device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.active }}
										</td>
									</tr>
									<tr>
										<th i18n="@@deviceLookup-installionPropertyPendingInstalls">pendingInstalls:</th>
										<td>
											{{
												device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location
													?.pendingInstalls
											}}
										</td>
									</tr>
								</table>
							</div>
						}
						@if (device.activeDeviceAssignment?.activeInstallation?.installationLocation) {
							<div class="section">
								<h2 i18n="@@deviceLookup-installationLocation">Installation Location</h2>
								<table>
									<tr>
										<th i18n="@@deviceLookup-installationLocationId">id:</th>
										<td>{{ device.activeDeviceAssignment?.activeInstallation?.installationLocation?.id }}</td>
									</tr>
									<tr>
										<th i18n="@@deviceLookup-installationLocationName">name:</th>
										<td>{{ device.activeDeviceAssignment?.activeInstallation?.installationLocation?.name }}</td>
									</tr>
									<tr>
										<th i18n="@@deviceLookup-installationLocationLocationId">locationId:</th>
										<td>{{ device.activeDeviceAssignment?.activeInstallation?.installationLocation?.locationId }}</td>
									</tr>
									<tr>
										<th i18n="@@deviceLookup-installationLocationMountingBracketInstalled">
											mountingBracketInstalled:
										</th>
										<td>
											{{
												device.activeDeviceAssignment?.activeInstallation?.installationLocation
													?.mountingBracketInstalled
											}}
										</td>
									</tr>
								</table>
							</div>
						}
						@if (device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.address) {
							<div class="section">
								<h2 i18n="@@deviceLookup-propertyAddress">Property Address</h2>
								<table>
									<tr>
										<th i18n="@@deviceLookup-propertyAddressId">id:</th>
										<td>
											{{
												device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.address?.id
											}}
										</td>
									</tr>
									<tr>
										<th i18n="@@deviceLookup-propertyAddressAddress1">address1:</th>
										<td>
											{{
												device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.address
													?.address1
											}}
										</td>
									</tr>
									<tr>
										<th i18n="@@deviceLookup-propertyAddressAddress2">address2:</th>
										<td>
											{{
												device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.address
													?.address2
											}}
										</td>
									</tr>
									<tr>
										<th i18n="@@deviceLookup-propertyAddressLocality">locality:</th>
										<td>
											{{
												device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.address
													?.locality
											}}
										</td>
									</tr>
									<tr>
										<th i18n="@@deviceLookup-propertyAddressPostalCode">postalCode:</th>
										<td>
											{{
												device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.address
													?.postalCode
											}}
										</td>
									</tr>
									<tr>
										<th i18n="@@deviceLookup-propertyAddressCountryCode">countryCode:</th>
										<td>
											{{
												device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.address
													?.countryCode
											}}
										</td>
									</tr>
								</table>
							</div>
						}
						@if (
							device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.address?.geoCoordinates
						) {
							<div class="section">
								<h2 i18n="@@deviceLookup-addressGeoCoordinates">Address Geocoordinates</h2>
								<table>
									<tr>
										<th i18n="@@deviceLookup-addressGeoCoordinatesLatitude">latitude:</th>
										<td>
											{{
												device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.address
													?.geoCoordinates?.latitude
											}}
										</td>
									</tr>
									<tr>
										<th i18n="@@deviceLookup-addressGeoCoordinatesLongitude">longitude:</th>
										<td>
											{{
												device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.address
													?.geoCoordinates?.longitude
											}}
										</td>
									</tr>
								</table>
							</div>
						}
					</div>
				</app-cards>
			</div>
		}
	</div>
}
